import React from 'react'

import {
  DateTimeField,
  FieldSpec,
  PaginatedTable,
  RelatedLinkedField,
  ShipmentStatusField,
  UnitLocUnitField,
  ValueField,
} from 'src/components/Table'
import { ListTableProps } from './types'

const fieldOptions: { [key: string]: FieldSpec } = {
  shipment: {
    id: 'shipment',
    label: 'Shipment',
    ordering: 'shipment__carrier__name,shipment__tracking_number',
    renderer: RelatedLinkedField(ValueField, 'name'),
  },
  status: {
    id: 'shipment.status',
    label: 'Shipment Status',
    ordering: 'shipment__status',
    renderer: ShipmentStatusField,
  },
  order: {
    id: 'shipment.order',
    label: 'Order',
    ordering: 'shipment__order__number',
    renderer: RelatedLinkedField(ValueField, 'name'),
  },
  shippedOn: {
    id: 'shipment.shippedOn',
    label: 'Shipped On',
    ordering: 'shipment.shippedOn',
    renderer: DateTimeField,
  },
  productName: {
    id: 'sku.productName',
    label: 'Product Name',
    ordering: 'sku__product_name',
    renderer: ValueField,
  },
  product: {
    id: 'product',
    label: 'Product',
    ordering: 'sku__sku',
    renderer: RelatedLinkedField(ValueField, 'name'),
  },
  sku: {
    id: 'sku',
    label: 'SKU',
    ordering: 'sku__sku',
    renderer: RelatedLinkedField(ValueField, 'name'),
  },
  batch: {
    id: 'batch',
    label: 'Batch',
    ordering: 'batch__client_uid',
    renderer: RelatedLinkedField(ValueField, 'name'),
  },
  numUnits: {
    id: 'numUnits',
    label: 'Number of Units',
    ordering: 'num_units',
    renderer: UnitLocUnitField,
  },
  container: {
    id: 'container',
    label: 'Container',
    renderer: RelatedLinkedField(ValueField, 'name'),
  },
}

export const ParcelShipmentUnitListTable = (props: ListTableProps) => {
  const { paginator, fields, title } = props

  return (
    <>
      <PaginatedTable
        title={title ? title : 'Units in Active Parcel Shipments'}
        fields={fields.map((field) => fieldOptions[field])}
        paginator={paginator}
      />
    </>
  )
}
